import type { LinkProps } from 'react-router'

export const createLinkExternalProps = (isExternal: boolean): Pick<LinkProps, 'rel' | 'target'> | null =>
  isExternal ? { rel: 'external', target: '_blank' } : null
